"use client";
var __create = Object.create;
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __getProtoOf = Object.getPrototypeOf;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __commonJS = (cb, mod) => function __require() {
  return mod || (0, cb[__getOwnPropNames(cb)[0]])((mod = { exports: {} }).exports, mod), mod.exports;
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toESM = (mod, isNodeMode, target) => (target = mod != null ? __create(__getProtoOf(mod)) : {}, __copyProps(
  // If the importer is in node compatibility mode or this is not an ESM
  // file that has been converted to a CommonJS file using a Babel-
  // compatible transform (i.e. "__esModule" has not been set), then set
  // "default" to the CommonJS "module.exports" for node compatibility.
  isNodeMode || !mod || !mod.__esModule ? __defProp(target, "default", { value: mod, enumerable: true }) : target,
  mod
));

// ../../node_modules/.pnpm/deepmerge@4.3.1/node_modules/deepmerge/dist/cjs.js
var require_cjs = __commonJS({
  "../../node_modules/.pnpm/deepmerge@4.3.1/node_modules/deepmerge/dist/cjs.js"(exports, module) {
    "use strict";
    var isMergeableObject2 = function isMergeableObject3(value) {
      return isNonNullObject(value) && !isSpecial(value);
    };
    function isNonNullObject(value) {
      return !!value && typeof value === "object";
    }
    function isSpecial(value) {
      var stringValue = Object.prototype.toString.call(value);
      return stringValue === "[object RegExp]" || stringValue === "[object Date]" || isReactElement(value);
    }
    var canUseSymbol2 = typeof Symbol === "function" && Symbol.for;
    var REACT_ELEMENT_TYPE = canUseSymbol2 ? Symbol.for("react.element") : 60103;
    function isReactElement(value) {
      return value.$$typeof === REACT_ELEMENT_TYPE;
    }
    function emptyTarget(val) {
      return Array.isArray(val) ? [] : {};
    }
    function cloneUnlessOtherwiseSpecified(value, options) {
      return options.clone !== false && options.isMergeableObject(value) ? deepmerge(emptyTarget(value), value, options) : value;
    }
    function defaultArrayMerge(target, source, options) {
      return target.concat(source).map(function(element) {
        return cloneUnlessOtherwiseSpecified(element, options);
      });
    }
    function getMergeFunction(key, options) {
      if (!options.customMerge) {
        return deepmerge;
      }
      var customMerge = options.customMerge(key);
      return typeof customMerge === "function" ? customMerge : deepmerge;
    }
    function getEnumerableOwnPropertySymbols(target) {
      return Object.getOwnPropertySymbols ? Object.getOwnPropertySymbols(target).filter(function(symbol) {
        return Object.propertyIsEnumerable.call(target, symbol);
      }) : [];
    }
    function getKeys(target) {
      return Object.keys(target).concat(getEnumerableOwnPropertySymbols(target));
    }
    function propertyIsOnObject(object, property) {
      try {
        return property in object;
      } catch (_2) {
        return false;
      }
    }
    function propertyIsUnsafe(target, key) {
      return propertyIsOnObject(target, key) && !(Object.hasOwnProperty.call(target, key) && Object.propertyIsEnumerable.call(target, key));
    }
    function mergeObject(target, source, options) {
      var destination = {};
      if (options.isMergeableObject(target)) {
        getKeys(target).forEach(function(key) {
          destination[key] = cloneUnlessOtherwiseSpecified(target[key], options);
        });
      }
      getKeys(source).forEach(function(key) {
        if (propertyIsUnsafe(target, key)) {
          return;
        }
        if (propertyIsOnObject(target, key) && options.isMergeableObject(source[key])) {
          destination[key] = getMergeFunction(key, options)(target[key], source[key], options);
        } else {
          destination[key] = cloneUnlessOtherwiseSpecified(source[key], options);
        }
      });
      return destination;
    }
    function deepmerge(target, source, options) {
      options = options || {};
      options.arrayMerge = options.arrayMerge || defaultArrayMerge;
      options.isMergeableObject = options.isMergeableObject || isMergeableObject2;
      options.cloneUnlessOtherwiseSpecified = cloneUnlessOtherwiseSpecified;
      var sourceIsArray = Array.isArray(source);
      var targetIsArray = Array.isArray(target);
      var sourceAndTargetTypesMatch = sourceIsArray === targetIsArray;
      if (!sourceAndTargetTypesMatch) {
        return cloneUnlessOtherwiseSpecified(source, options);
      } else if (sourceIsArray) {
        return options.arrayMerge(target, source, options);
      } else {
        return mergeObject(target, source, options);
      }
    }
    deepmerge.all = function deepmergeAll(array, options) {
      if (!Array.isArray(array)) {
        throw new Error("first argument should be an array");
      }
      return array.reduce(function(prev, next) {
        return deepmerge(prev, next, options);
      }, {});
    };
    var deepmerge_1 = deepmerge;
    module.exports = deepmerge_1;
  }
});

// src/system.tsx
import * as React from "react";
function systemForwardRef(comp) {
  return React.forwardRef(comp);
}

// src/hooks.ts
import "react";
import { error } from "@stepstone-genesis/utilities";

// src/context/emotion-instance.tsx
import * as React3 from "react";
import { useMemoOnce } from "@stepstone-genesis/hooks-use-memo-once";
import createEmotionCache from "@emotion/cache";
import {
  keyframes,
  css as css2,
  CacheProvider as EmotionCacheProvider
} from "@emotion/react";

// ../libraries/deep-merge/src/index.ts
var import_deepmerge = __toESM(require_cjs());

// src/theme-ui/core/index.ts
var canUseSymbol = typeof Symbol === "function" && Symbol.for;
var REACT_ELEMENT = canUseSymbol ? Symbol.for("react.element") : 60103;
var FORWARD_REF = canUseSymbol ? Symbol.for("react.forward_ref") : 60103;
var isMergeableObject = (n) => {
  return !!n && typeof n === "object" && n.$$typeof !== REACT_ELEMENT && n.$$typeof !== FORWARD_REF;
};
var arrayMerge = (_destinationArray, sourceArray, _options) => sourceArray;
var merge = (a, b) => (0, import_deepmerge.default)(a, b, { isMergeableObject, arrayMerge });
function mergeAll(...args) {
  return import_deepmerge.default.all(args, { isMergeableObject, arrayMerge });
}
merge.all = mergeAll;

// src/theme-ui/style-system/aliases.ts
var aliases = {
  bg: "backgroundColor",
  m: "margin",
  mt: "marginTop",
  mr: "marginRight",
  mb: "marginBottom",
  ml: "marginLeft",
  mx: "marginX",
  my: "marginY",
  p: "padding",
  pt: "paddingTop",
  pr: "paddingRight",
  pb: "paddingBottom",
  pl: "paddingLeft",
  px: "paddingX",
  py: "paddingY"
};

// src/theme-ui/style-system/multiples.ts
var multiples = {
  marginX: ["marginLeft", "marginRight"],
  marginY: ["marginTop", "marginBottom"],
  paddingX: ["paddingLeft", "paddingRight"],
  paddingY: ["paddingTop", "paddingBottom"],
  scrollMarginX: ["scrollMarginLeft", "scrollMarginRight"],
  scrollMarginY: ["scrollMarginTop", "scrollMarginBottom"],
  scrollPaddingX: ["scrollPaddingLeft", "scrollPaddingRight"],
  scrollPaddingY: ["scrollPaddingTop", "scrollPaddingBottom"],
  size: ["width", "height"]
};

// src/theme-ui/style-system/scales.ts
var scales = {
  color: "colors",
  background: "colors",
  backgroundColor: "colors",
  borderColor: "colors",
  caretColor: "colors",
  columnRuleColor: "colors",
  outlineColor: "colors",
  textDecorationColor: "colors",
  opacity: "opacities",
  transition: "transitions",
  margin: "space",
  marginTop: "space",
  marginRight: "space",
  marginBottom: "space",
  marginLeft: "space",
  marginX: "space",
  marginY: "space",
  marginBlock: "space",
  marginBlockEnd: "space",
  marginBlockStart: "space",
  marginInline: "space",
  marginInlineEnd: "space",
  marginInlineStart: "space",
  padding: "space",
  paddingTop: "space",
  paddingRight: "space",
  paddingBottom: "space",
  paddingLeft: "space",
  paddingX: "space",
  paddingY: "space",
  paddingBlock: "space",
  paddingBlockEnd: "space",
  paddingBlockStart: "space",
  paddingInline: "space",
  paddingInlineEnd: "space",
  paddingInlineStart: "space",
  scrollMargin: "space",
  scrollMarginTop: "space",
  scrollMarginRight: "space",
  scrollMarginBottom: "space",
  scrollMarginLeft: "space",
  scrollMarginX: "space",
  scrollMarginY: "space",
  scrollPadding: "space",
  scrollPaddingTop: "space",
  scrollPaddingRight: "space",
  scrollPaddingBottom: "space",
  scrollPaddingLeft: "space",
  scrollPaddingX: "space",
  scrollPaddingY: "space",
  inset: "space",
  insetBlock: "space",
  insetBlockEnd: "space",
  insetBlockStart: "space",
  insetInline: "space",
  insetInlineEnd: "space",
  insetInlineStart: "space",
  top: "space",
  right: "space",
  bottom: "space",
  left: "space",
  gridGap: "space",
  gridColumnGap: "space",
  gridRowGap: "space",
  gap: "space",
  columnGap: "space",
  rowGap: "space",
  fontFamily: "fonts",
  fontSize: "fontSizes",
  fontWeight: "fontWeights",
  lineHeight: "lineHeights",
  letterSpacing: "letterSpacings",
  border: "borders",
  borderTop: "borders",
  borderRight: "borders",
  borderBottom: "borders",
  borderLeft: "borders",
  borderWidth: "borderWidths",
  borderStyle: "borderStyles",
  borderRadius: "radii",
  borderTopRightRadius: "radii",
  borderTopLeftRadius: "radii",
  borderBottomRightRadius: "radii",
  borderBottomLeftRadius: "radii",
  borderTopWidth: "borderWidths",
  borderTopColor: "colors",
  borderTopStyle: "borderStyles",
  borderBottomWidth: "borderWidths",
  borderBottomColor: "colors",
  borderBottomStyle: "borderStyles",
  borderLeftWidth: "borderWidths",
  borderLeftColor: "colors",
  borderLeftStyle: "borderStyles",
  borderRightWidth: "borderWidths",
  borderRightColor: "colors",
  borderRightStyle: "borderStyles",
  borderBlock: "borders",
  borderBlockColor: "colors",
  borderBlockEnd: "borders",
  borderBlockEndColor: "colors",
  borderBlockEndStyle: "borderStyles",
  borderBlockEndWidth: "borderWidths",
  borderBlockStart: "borders",
  borderBlockStartColor: "colors",
  borderBlockStartStyle: "borderStyles",
  borderBlockStartWidth: "borderWidths",
  borderBlockStyle: "borderStyles",
  borderBlockWidth: "borderWidths",
  borderEndEndRadius: "radii",
  borderEndStartRadius: "radii",
  borderInline: "borders",
  borderInlineColor: "colors",
  borderInlineEnd: "borders",
  borderInlineEndColor: "colors",
  borderInlineEndStyle: "borderStyles",
  borderInlineEndWidth: "borderWidths",
  borderInlineStart: "borders",
  borderInlineStartColor: "colors",
  borderInlineStartStyle: "borderStyles",
  borderInlineStartWidth: "borderWidths",
  borderInlineStyle: "borderStyles",
  borderInlineWidth: "borderWidths",
  borderStartEndRadius: "radii",
  borderStartStartRadius: "radii",
  columnRuleWidth: "borderWidths",
  boxShadow: "shadows",
  textShadow: "shadows",
  zIndex: "zIndices",
  width: "sizes",
  minWidth: "sizes",
  maxWidth: "sizes",
  height: "sizes",
  minHeight: "sizes",
  maxHeight: "sizes",
  flexBasis: "sizes",
  size: "sizes",
  blockSize: "sizes",
  inlineSize: "sizes",
  maxBlockSize: "sizes",
  maxInlineSize: "sizes",
  minBlockSize: "sizes",
  minInlineSize: "sizes",
  columnWidth: "sizes",
  // svg
  fill: "colors",
  stroke: "colors"
};

// src/theme-ui/css/index.ts
function get(obj, key, def, p, undef) {
  const path = key && typeof key === "string" ? key.split(".") : [key];
  for (p = 0; p < path.length; p++) {
    obj = obj ? obj[path[p]] : undef;
  }
  return obj === undef ? def : obj;
}
var defaultBreakpoints = [40, 52, 64].map((n) => n + "em");
var defaultTheme = {
  space: [0, 4, 8, 16, 32, 64, 128, 256, 512],
  fontSizes: [12, 14, 16, 20, 24, 32, 48, 64, 72]
};
var positiveOrNegative = (scale, value) => {
  if (typeof value !== "number" || value >= 0) {
    if (typeof value === "string" && value.startsWith("-")) {
      const valueWithoutMinus = value.substring(1);
      const n2 = get(scale, valueWithoutMinus, valueWithoutMinus);
      return `-${n2}`;
    }
    return get(scale, value, value);
  }
  const absolute = Math.abs(value);
  const n = get(scale, absolute, absolute);
  if (typeof n === "string") return "-" + n;
  return Number(n) * -1;
};
var transforms = [
  "margin",
  "marginTop",
  "marginRight",
  "marginBottom",
  "marginLeft",
  "marginX",
  "marginY",
  "marginBlock",
  "marginBlockEnd",
  "marginBlockStart",
  "marginInline",
  "marginInlineEnd",
  "marginInlineStart",
  "top",
  "bottom",
  "left",
  "right"
].reduce(
  (acc, curr) => ({
    ...acc,
    [curr]: positiveOrNegative
  }),
  {}
);
var responsive = (styles) => (theme) => {
  const next = {};
  const breakpoints = theme && theme.breakpoints || defaultBreakpoints;
  const mediaQueries = [
    null,
    ...breakpoints.map((n) => `@media screen and (min-width: ${n})`)
  ];
  for (const k in styles) {
    const key = k;
    let value = styles[key];
    if (typeof value === "function") {
      value = value(theme || {});
    }
    if (value == null) continue;
    if (!Array.isArray(value)) {
      next[key] = value;
      continue;
    }
    for (let i = 0; i < value.slice(0, mediaQueries.length).length; i++) {
      const media = mediaQueries[i];
      if (!media) {
        next[key] = value[i];
        continue;
      }
      next[media] = next[media] || {};
      if (value[i] == null) continue;
      next[media][key] = value[i];
    }
  }
  return next;
};
var css = (args = {}) => (props = {}) => {
  const theme = {
    ...defaultTheme,
    ..."theme" in props ? props.theme : props
  };
  let result = {};
  const obj = typeof args === "function" ? args(theme) : args;
  const styles = responsive(obj)(theme);
  for (const key in styles) {
    const x = styles[key];
    const val = typeof x === "function" ? x(theme) : x;
    if (key === "variant") {
      const variant = css(get(theme, val))(theme);
      result = { ...result, ...variant };
      continue;
    }
    if (val && typeof val === "object") {
      result[key] = css(val)(theme);
      continue;
    }
    const prop = key in aliases ? aliases[key] : key;
    const scaleName = prop in scales ? scales[prop] : void 0;
    const scale = get(theme, scaleName, get(theme, prop, {}));
    const transform = get(transforms, prop, get);
    const value = transform(scale, val, val);
    if (prop in multiples) {
      const dirs = multiples[prop];
      for (let i = 0; i < dirs.length; i++) {
        result[dirs[i]] = value;
      }
    } else {
      result[prop] = value;
    }
  }
  return result;
};

// src/theme-ui/style-system/pseudos.ts
var pseudoSelectors = {
  _firstChild: "&:first-of-type:not(style):not(:first-of-type:not(style) ~ *)",
  _lastChild: "&:last-child",
  _hover: "&:hover",
  _active: "&:active, &[data-active=true]",
  _focus: "&:focus, &[data-focus]",
  _visited: "&:visited",
  _even: "&:nth-of-type(even)",
  _odd: "&:nth-of-type(odd)",
  _disabled: "&:disabled, &:disabled:focus, &:disabled:hover, &[aria-disabled=true], &[aria-disabled=true]:focus, &[aria-disabled=true]:hover, &[data-disabled], &[data-disabled]:focus, &[data-disabled]:hover",
  _checked: "&[aria-checked=true], &[data-checked], &:checked",
  _notChecked: "&:not([checked]), &:not([aria-checked]), &:not([data-checked])",
  _mixed: "&[aria-checked=mixed]",
  _selected: "&[aria-selected=true], &[data-selected=true]",
  _invalid: "&[aria-invalid=true], &[data-invalid]",
  _valid: "&[aria-valid=true], &[data-valid]",
  _pressed: "&[aria-pressed=true], &[data-pressed]",
  _readOnly: "&[aria-readonly=true], &[readonly], &[data-readonly]",
  _first: "&:first-of-type",
  _last: "&:last-of-type",
  _expanded: "&[aria-expanded=true]",
  _notExpanded: "&[aria-expanded=false]",
  _grabbed: "&[aria-grabbed=true]",
  _notFirst: "&:not(:first-of-type)",
  _notLast: "&:not(:last-of-type)",
  _groupHover: "[role=group]:hover &",
  _before: "&:before",
  _after: "&:after",
  _placeholder: "&::placeholder",
  _focusWithIn: "&:focus-within",
  _focusVisible: "&:focus-visible",
  __moz_focus_inner: "&::-moz-focus-inner",
  _empty: "&:empty",
  _autofill: "&:-webkit-autofill",
  _hidden: "&[aria-hidden=true], &[hidden], &[data-hidden]"
};

// src/context/emotion-instance.tsx
import { __DEV__ as __DEV__2 } from "@stepstone-genesis/utilities";

// src/base/apply-theme.ts
import * as React2 from "react";
import { isArray } from "@stepstone-genesis/utilities";

// src/style-system/themes.ts
import { __DEV__ } from "@stepstone-genesis/utilities";
var defaultBreakpoints2 = [40, 52, 64].map((n) => n + "em");
var positiveOrNegative2 = (scale, value) => {
  var _a, _b, _c;
  if (typeof value !== "number" || value >= 0) {
    if (typeof value === "string" && value[0] === "-") {
      const valueWithoutMinus = value.substring(1);
      const n2 = (_a = scale[valueWithoutMinus]) != null ? _a : valueWithoutMinus;
      if (typeof n2 === "number") {
        return n2 * -1;
      }
      return `-${n2}`;
    }
    return (_b = scale[value]) != null ? _b : value;
  }
  const absolute = Math.abs(value);
  const n = (_c = scale[absolute]) != null ? _c : absolute;
  if (typeof n === "string") return "-" + n;
  return Number(n) * -1;
};
var allowNegative = /* @__PURE__ */ new Set([
  "margin",
  "marginTop",
  "marginRight",
  "marginBottom",
  "marginLeft",
  "marginX",
  "marginY",
  "marginBlock",
  "marginBlockEnd",
  "marginBlockStart",
  "marginInline",
  "marginInlineEnd",
  "marginInlineStart",
  "top",
  "bottom",
  "left",
  "right"
]);
var getMediaQueries = (theme) => {
  var _a;
  const breakpoints = (_a = theme.breakpoints) != null ? _a : defaultBreakpoints2;
  const mediaQueries = [null];
  for (let i = 0; i < breakpoints.length; i++) {
    const width = breakpoints[i];
    mediaQueries.push(`@media screen and (min-width: ${width})`);
  }
  return mediaQueries;
};
var createCss = (theme) => {
  const propScales = /* @__PURE__ */ new Map();
  const getScaleForProp = (prop) => {
    const maybeCachedScale = propScales.get(prop);
    if (maybeCachedScale !== void 0) {
      return maybeCachedScale != null ? maybeCachedScale : void 0;
    }
    let scale = void 0;
    if (prop in scales) {
      const scaleName = scales[prop];
      if (scaleName) {
        scale = theme[scaleName];
      }
    }
    if (!scale) {
      scale = theme[prop];
    }
    propScales.set(prop, scale != null ? scale : null);
    return scale;
  };
  const doCssObject = (result, args) => {
    const obj = typeof args === "function" ? args(theme) : args;
    const styles = obj;
    for (const key in styles) {
      if (__DEV__) {
        if (key === "0" || !isNaN(parseInt(key))) {
          throw new Error(
            "Tried to pass an array-ish object as a style:\n" + JSON.stringify(styles, null, 2)
          );
        }
      }
      const value = styles[key];
      doStyleValue(result, key, value);
    }
    finalizeMediaQueries(result);
  };
  const doStyleValue = (result, key, valOrFn) => {
    const val = typeof valOrFn === "function" ? valOrFn(theme) : valOrFn;
    if (val && typeof val === "object") {
      if (Array.isArray(val)) {
        doResponsiveValue(result, key, val);
        return;
      } else {
        doNestedCssObject(result, key, val);
        return;
      }
    }
    doNonResponsiveValue(result, key, val);
  };
  const doNestedCssObject = (result, key, val) => {
    var _a;
    const outputKey = (_a = pseudoSelectors[key]) != null ? _a : key;
    const existingValue = result[outputKey];
    if (existingValue !== void 0 && typeof existingValue !== "object") {
      throw new Error(
        `Internal error while processing nested style object: result already has a value ${key}, but it isn't an object:
` + JSON.stringify(existingValue)
      );
    }
    const nestedResult = existingValue != null ? existingValue : {};
    doCssObject(nestedResult, val);
    result[outputKey] = nestedResult;
  };
  const assertIsNotObject = (x) => {
    if (x && typeof x === "object") {
      throw new Error("Got unexpected object:\n" + JSON.stringify(x));
    }
  };
  const doNonResponsiveValue = (result, key, val) => {
    var _a;
    if (val === null || val === void 0) {
      return;
    }
    const prop = key in aliases ? aliases[key] : key;
    const scale = getScaleForProp(prop);
    let value;
    if (!scale) {
      value = val;
    } else if (allowNegative.has(prop)) {
      value = positiveOrNegative2(scale, val);
    } else {
      value = (_a = scale[val]) != null ? _a : val;
    }
    const maybeDirs = multiples[prop];
    if (maybeDirs) {
      const dirs = maybeDirs;
      for (let i = 0; i < dirs.length; i++) {
        result[dirs[i]] = value;
      }
    } else {
      result[prop] = value;
    }
  };
  const mediaQueries = getMediaQueries(theme);
  const doResponsiveValue = (result, key, value) => {
    const len = Math.min(value.length, mediaQueries.length);
    if (len >= 1) {
      if (__DEV__) assertIsNotObject(value[0]);
      doNonResponsiveValue(result, key, value[0]);
    }
    for (let i = 1; i < len; i++) {
      if (__DEV__) assertIsNotObject(value[i]);
      const mediaQuery = mediaQueries[i];
      if (value[i] == null) continue;
      const targetQuery = result[mediaQuery] || (result[mediaQuery] = {});
      doNonResponsiveValue(targetQuery, key, value[i]);
    }
    return result;
  };
  const finalizeMediaQueries = (result) => {
    for (let i = 1; i < mediaQueries.length; i++) {
      const mediaQuery = mediaQueries[i];
      const queryStyles = result[mediaQuery];
      if (queryStyles) {
        delete result[mediaQuery];
        result[mediaQuery] = queryStyles;
      }
    }
  };
  const css3 = (args) => {
    const result = {};
    doCssObject(result, args);
    return result;
  };
  const cssAll = (argArray) => {
    const result = {};
    for (let i = 0, len = argArray.length; i < len; i++) {
      const arg = argArray[i];
      if (!arg) continue;
      doCssObject(result, arg);
    }
    return result;
  };
  return { css: css3, cssAll };
};

// src/base/apply-theme.ts
var __internalCastStyleProp = (arg) => arg;
var mergeStyles = (styles) => (
  /*@__INLINE__*/
  __internalCastStyleProp(styles)
);
var __inefficientlyShallowMergeStyles = (styles) => {
  const normalized = normalizeStyleTree(styles);
  const result = {};
  for (let i = 0, len = normalized.length; i < len; i++) {
    Object.assign(result, normalized[i]);
  }
  return result;
};
var normalizeStyleTree = (styles) => {
  const result = [];
  const visit = (styles2) => {
    if (!styles2) return;
    if (!isArray(styles2)) {
      result.push(styles2);
      return;
    }
    for (let i = 0, len = styles2.length; i < len; i++) {
      visit(styles2[i]);
    }
  };
  visit(styles);
  return result;
};
var createCssFn = (theme) => {
  const { css: css3, cssAll } = createCss(theme);
  const styleFn = (styles) => {
    if (!styles) return void 0;
    if (isArray(styles)) {
      const normalized = normalizeStyleTree(styles);
      return cssAll(normalized);
    }
    return css3(styles);
  };
  return styleFn;
};
var useApplyTheme = (theme) => {
  return React2.useMemo(() => createCssFn(theme), [theme]);
};

// src/context/emotion-instance.tsx
import { isFunction } from "@stepstone-genesis/utilities";
import { Global } from "@emotion/react";
var createStyleCache = () => {
  return {
    cache: /* @__PURE__ */ new Map(),
    stats: { calls: 0, hits: 0, misses: 0, bailouts: 0 }
  };
};
var useStyleCache = () => {
  const { GENESIS_STYLE_CACHE } = useEmotionInstanceContext();
  return GENESIS_STYLE_CACHE;
};
var EmotionInstanceContext = React3.createContext(void 0);
var EmotionCacheContext = React3.createContext(null);
var useEmotionCache = () => {
  const cache = React3.useContext(EmotionCacheContext);
  if (!cache) {
    throw new Error("Missing EmotionCacheContext");
  }
  return cache;
};
var useEmotionInstanceContext = () => {
  const context = React3.useContext(EmotionInstanceContext);
  if (!context) {
    throw new Error(
      "useEmotionInstanceContext must be used within InstanceProvider.\n\nIf you have an InstanceProvider but you're still getting this error,\nyou probably have mismatching version of genesis packages (components, hooks, icons, system).\nThis usually happens when one of the genesis packages is out of sync with the rest.\nMake sure you're using the latest version of all the genesis packages.\n\nYou can also try removing your package-lock.json and reinstalling with `npm install`."
    );
  }
  return context;
};
var createCustomInstance = ({
  styleCache: styleCacheEnabled = true,
  ...rest
}) => {
  const createCache = () => createEmotionCache(rest);
  const styleCache = styleCacheEnabled ? createStyleCache() : null;
  return {
    key: rest.key,
    GENESIS_STYLE_CACHE: styleCache,
    keyframes,
    css: css2,
    createCache
  };
};
var systemEmotionInstance = createCustomInstance({ key: "stst-css" });
var InstanceProvider = ({ instance = systemEmotionInstance, cache, children }) => {
  const internalInstance = useMemoOnce(() => instance);
  const internalCache = useMemoOnce(
    () => cache != null ? cache : instance.createCache()
  );
  if (typeof window === "undefined") {
    if (internalCache.wasUsed) {
      throw new Error(
        "Cache instance can't be used twice, please create a new cache instance for every main server renderer."
      );
    } else {
      internalCache.wasUsed = true;
    }
    if (!cache) {
      throw new Error(
        "InstanceProvider should receive a cache (fresh for every request) when used for SSR"
      );
    }
  }
  return /* @__PURE__ */ React3.createElement(EmotionInstanceContext.Provider, { value: internalInstance }, /* @__PURE__ */ React3.createElement(EmotionCacheContext.Provider, { value: internalCache }, /* @__PURE__ */ React3.createElement(EmotionCacheProvider, { value: internalCache }, children)));
};
var jsonNoFunctionsReplacer = (_2, val) => {
  if (typeof val === "function") throw new SerializeFunctionError();
  return val;
};
var SerializeFunctionError = class extends Error {
};
var getStylePropsHash = (props, theme) => {
  try {
    return theme.__theme__ + "/" + JSON.stringify(props, jsonNoFunctionsReplacer);
  } catch (err) {
    if (err instanceof SerializeFunctionError) {
      return null;
    }
    throw err;
  }
};
var __EMOTION_VERSION__ = "11.13.5 ";
var Context = React3.createContext({
  __EMOTION_VERSION__,
  theme: {}
});
var useTheme = () => React3.useContext(Context);
var ThemeProvider = ({
  theme,
  children,
  globalStyles
}) => {
  const outer = useTheme();
  if (__DEV__2) {
    if (outer.__EMOTION_VERSION__ !== __EMOTION_VERSION__) {
      console.warn(
        "Multiple versions of Emotion detected,",
        "and theming might not work as expected.",
        "Please ensure there is only one copy of @emotion/core installed in your application."
      );
    }
  }
  const context = React3.useMemo(
    () => typeof theme === "function" ? { ...outer, theme: theme(outer.theme) } : merge.all({}, outer, { theme }),
    [theme, outer]
  );
  return /* @__PURE__ */ React3.createElement(Context.Provider, { value: context }, globalStyles && /* @__PURE__ */ React3.createElement(GlobalStyles, { styles: globalStyles }), children);
};
var GlobalStyles = ({
  styles
}) => {
  const { theme } = useTheme();
  const applied = isFunction(styles) ? styles(theme) : styles;
  const emotionCache = useEmotionCache();
  const { serialized } = useStylesInternal(
    {
      sx: applied,
      defaults: false
      // emotion does stupid stuff when we add our DEFAULT_STYLES to these rules
    },
    emotionCache
  );
  return /* @__PURE__ */ React3.createElement(Global, { styles: serialized });
};
var useGlobalStyles = (styles) => {
  console.error("useGlobalStyles: ignoring global styles", styles);
  throw new Error("TODO (incompatible with 18)");
};
var DEFAULT_STYLES = {
  boxSizing: "border-box",
  margin: 0,
  minWidth: 0
};
var DEBUG_STYLES = { outline: "1px solid red !important" };
var useStylesInternal = (props, emotionCache) => {
  const {
    sx,
    __root,
    css: cssStyles,
    debug = false,
    propStyles,
    defaults = true
  } = props;
  const { theme } = useTheme();
  const applyTheme = useApplyTheme(theme);
  const cacheCtx = useStyleCache();
  let hashedProps = null;
  if (cacheCtx) {
    if (__DEV__2) cacheCtx.stats.calls += 1;
    hashedProps = getStylePropsHash(props, theme);
    if (hashedProps !== null) {
      const existing = cacheCtx.cache.get(hashedProps);
      if (existing) {
        if (__DEV__2) {
          cacheCtx.stats.hits += 1;
        }
        return existing;
      } else if (__DEV__2) {
        cacheCtx.stats.misses += 1;
      }
    } else if (__DEV__2) {
      cacheCtx.stats.bailouts += 1;
    }
  }
  const deThemedCss = applyTheme(
    mergeStyles([
      defaults ? DEFAULT_STYLES : void 0,
      /*@__INLINE__*/
      __internalCastStyleProp(__root),
      propStyles,
      // allows for m={} p={} etc
      /*@__INLINE__*/
      __internalCastStyleProp(sx),
      // theme aware props
      /*@__INLINE__*/
      __internalCastStyleProp(cssStyles),
      debug ? DEBUG_STYLES : void 0
    ])
  );
  const emotionArg = Array.isArray(deThemedCss) ? deThemedCss : [deThemedCss];
  const serializedStyles = css2(emotionArg);
  const generatedClassname = `${emotionCache.key}-${serializedStyles.name}`;
  const result = {
    serialized: serializedStyles,
    className: generatedClassname
  };
  if (cacheCtx && hashedProps !== null) {
    cacheCtx.cache.set(hashedProps, result);
  }
  return result;
};
var mergeClassnames = (left, right) => {
  if (!left) {
    return right;
  }
  if (!right) {
    return left;
  }
  return left + " " + right;
};

// src/hooks.ts
var useMergeStyles = (sources, dependencies, options) => {
  return mergeStyles(sources);
};
var createResponsiveVariant = (variants, variantStyles, theme) => {
  var _a;
  const mediaQueries = getMediaQueries(theme);
  if (!Array.isArray(variants)) {
    return (_a = variantStyles[variants]) != null ? _a : {};
  }
  if (variants.length === 0) {
    return {};
  }
  const styles = variants[0] ? { ...variantStyles[variants[0]] } : {};
  for (let i = 1; i < variants.length; i++) {
    if (variants[i] === null || variants[i] === void 0) {
      continue;
    }
    const currentVariantStyles = variantStyles[variants[i]];
    if (!currentVariantStyles) continue;
    const mediaQuery = mediaQueries[i];
    styles[mediaQuery] = currentVariantStyles;
  }
  return styles;
};
var useResponsiveVariant = (variants, variantStyles) => {
  const { theme } = useTheme();
  const responsiveVariantStyles = createResponsiveVariant(
    variants,
    variantStyles,
    theme
  );
  return responsiveVariantStyles;
};
var useMultipleResponsiveVariant = (variant, variantStyles, variantNames = []) => {
  const { theme } = useTheme();
  const multipleVariantStyleConfig = variantNames.reduce((obj, item) => {
    if (!variantStyles[item]) {
      error({
        message: `Variant names do not exist within 'variantStyles' - NAME: ${item}, VARIANT: ${JSON.stringify(
          variantStyles,
          null,
          2
        )}`,
        condition: true
      });
      return obj;
    }
    obj[item] = createResponsiveVariant(variant, variantStyles[item], theme);
    return obj;
  }, {});
  return multipleVariantStyleConfig;
};

// src/base/base.tsx
import "react";
import { jsx as emotionJsx } from "@emotion/react";
import { IS_CONCURRENT_REACT, __DEV__ as __DEV__3 } from "@stepstone-genesis/utilities";

// src/base/props.ts
import emotionIsPropValid from "@emotion/is-prop-valid";
var partitionBoxProps = (props) => {
  const styling = {
    sx: props.sx,
    __root: props.__root,
    css: props.css,
    debug: props.debug,
    propStyles: void 0
  };
  const rest = {};
  for (const key in props) {
    if (key in styling) {
      continue;
    }
    const val = props[key];
    if (stylingPropNamesSet.has(key)) {
      const propStyles = styling.propStyles || (styling.propStyles = {});
      propStyles[key] = val;
    } else if (!emotionIsPropValid(key)) {
      continue;
    } else {
      rest[key] = val;
    }
  }
  return { styling, rest };
};
var _ = true;
var spaceProps = {
  margin: _,
  marginTop: _,
  marginRight: _,
  marginBottom: _,
  marginLeft: _,
  marginX: _,
  marginY: _,
  marginBlock: _,
  marginBlockEnd: _,
  marginBlockStart: _,
  marginInline: _,
  marginInlineEnd: _,
  marginInlineStart: _,
  padding: _,
  paddingTop: _,
  paddingRight: _,
  paddingBottom: _,
  paddingLeft: _,
  paddingX: _,
  paddingY: _,
  paddingBlock: _,
  paddingBlockEnd: _,
  paddingBlockStart: _,
  paddingInline: _,
  paddingInlineEnd: _,
  paddingInlineStart: _,
  scrollPadding: _,
  scrollPaddingTop: _,
  scrollPaddingRight: _,
  scrollPaddingBottom: _,
  scrollPaddingLeft: _,
  scrollPaddingX: _,
  scrollPaddingY: _,
  inset: _,
  insetBlock: _,
  insetBlockEnd: _,
  insetBlockStart: _,
  insetInline: _,
  insetInlineEnd: _,
  insetInlineStart: _,
  top: _,
  right: _,
  bottom: _,
  left: _,
  gridGap: _,
  gridColumnGap: _,
  gridRowGap: _,
  gap: _,
  columnGap: _,
  rowGap: _,
  // Margin aliases
  m: _,
  mt: _,
  mb: _,
  ml: _,
  mr: _,
  mx: _,
  my: _,
  // Padding aliases
  p: _,
  pt: _,
  pr: _,
  pb: _,
  pl: _,
  px: _,
  py: _
};
var colorProps = {
  backgroundColor: _,
  bg: _,
  borderColor: _,
  borderTopColor: _,
  borderBottomColor: _,
  borderLeftColor: _,
  borderRightColor: _,
  caretColor: _,
  color: _,
  columnRuleColor: _,
  outlineColor: _,
  stroke: _
};
var stylingPropNames = [
  ...Object.keys(spaceProps),
  ...Object.keys(colorProps)
];
var stylingPropNamesSet = new Set(stylingPropNames);
var omit = (props) => {
  const res = {};
  for (const key in props) {
    if (emotionIsPropValid(key)) {
      res[key] = props[key];
    }
  }
  return res;
};

// src/base/base.tsx
var useStylesOld = (props, extraClassnames) => {
  const { styling: stylingProps } = partitionBoxProps(props);
  const cache = useEmotionCache();
  const { className: generatedClassname } = useStylesInternal(
    stylingProps,
    cache
  );
  if (IS_CONCURRENT_REACT) {
    console.warn(
      "`useStyles` is incompatible with SSR in React >= 18. Use `useStylesWithInsertion` instead."
    );
  }
  return mergeClassnames(generatedClassname, extraClassnames);
};
var useStyles = (props, extraClassnames) => {
  const cache = useEmotionCache();
  const { styling: stylingProps } = partitionBoxProps(props);
  let { className: generatedClassname, serialized } = useStylesInternal(
    stylingProps,
    cache
  );
  if (__DEV__3) {
    generatedClassname = generatedClassname + "-useStyles";
    serialized = { ...serialized, name: serialized.name + "-useStyles" };
  }
  const className = mergeClassnames(generatedClassname, extraClassnames);
  return [
    className,
    emotionJsx(
      NoopForInsertion,
      // @ts-expect-error  not sure how to make TS accept this, but it should work
      { css: serialized }
    )
  ];
};
var NoopForInsertion = () => null;
var Base = systemForwardRef(function Base2({ as: As = "div", className, children, ...props }, ref) {
  var _a;
  const cache = useEmotionCache();
  const { styling: stylingProps, rest: safeProps } = partitionBoxProps(props);
  const { serialized: serializedStyles } = useStylesInternal(
    stylingProps,
    cache
  );
  return emotionJsx(
    As,
    {
      ref,
      className,
      css: serializedStyles,
      "data-genesis-element": (_a = props.element) != null ? _a : "BASE",
      ...safeProps
    },
    children
  );
});

// src/style-config.ts
import { isFunction as isFunction2, mergeAll as mergeAll2, toArray } from "@stepstone-genesis/utilities";

// src/utils.ts
var EMPTY_OBJECT = Object.freeze({});
var EMPTY_ARRAY = Object.freeze([]);
var isEmptyObject = (obj) => {
  if (obj === EMPTY_OBJECT) {
    return true;
  }
  for (const _2 in obj) {
    return false;
  }
  return true;
};

// src/style-config.ts
function useStyleConfig(element, elementOpts) {
  const { theme } = useTheme();
  return applyStyleConfig(element, elementOpts, theme);
}
var NO_THEME_OVERRIDES = {
  base: {},
  variants: {},
  responsiveVariants: [],
  props: {}
};
var getThemeOverrides = (element, theme) => {
  var _a, _b, _c, _d;
  const overrides = (_a = theme.components) == null ? void 0 : _a[element];
  if (!overrides) {
    return NO_THEME_OVERRIDES;
  }
  const { styles = EMPTY_OBJECT, props } = overrides;
  return {
    base: (_b = styles.base) != null ? _b : EMPTY_OBJECT,
    variants: (_c = styles.variants) != null ? _c : EMPTY_OBJECT,
    responsiveVariants: (_d = styles.responsiveVariants) != null ? _d : EMPTY_ARRAY,
    props: props != null ? props : EMPTY_OBJECT
  };
};
var EMPTY_STYLES = {
  base: EMPTY_OBJECT,
  variants: EMPTY_OBJECT,
  responsiveVariants: EMPTY_ARRAY
};
var applyStyleConfig = (element, elementOpts, theme) => {
  const {
    styles = EMPTY_STYLES,
    props = EMPTY_OBJECT,
    mergeOrder = MERGE_ORDER_DEFAULT
  } = elementOpts;
  const themeOverrides = getThemeOverrides(element, theme);
  const mergedProps = getMergedProps(props, themeOverrides, theme);
  const combinedBaseStyles = getMergedBaseStyles(
    styles,
    themeOverrides,
    mergedProps,
    theme
  );
  const combinedVariantStyles = getMergedStylesFromVariants(
    styles,
    themeOverrides,
    mergedProps,
    theme
  );
  const combinedResponsiveVariantStyles = getMergedStylesFromResponsiveVariants(
    styles,
    themeOverrides,
    mergedProps,
    theme
  );
  const allStyles = orderStylesByMergeOrder(mergeOrder, {
    base: combinedBaseStyles,
    variants: combinedVariantStyles,
    responsiveVariants: combinedResponsiveVariantStyles
  });
  return {
    [element]: {
      styles: mergeAll2(allStyles),
      props: mergedProps
    }
  };
};
var containsVariantProp = (props) => {
  return !!props.variant;
};
function getMergedProps(props, themeOverrides, theme) {
  const hasThemeProps = !isEmptyObject(themeOverrides.props);
  const baseProps = isFunction2(props) ? props({ theme }) : props;
  if (hasThemeProps) {
    const themeOverridesProps = isFunction2(themeOverrides.props) ? themeOverrides.props({ theme, props: baseProps }) : themeOverrides.props;
    return mergeAll2([baseProps, themeOverridesProps]);
  } else {
    return baseProps;
  }
}
function getMergedBaseStyles(styles, themeOverrides, mergedProps, theme) {
  const hasThemeBase = !isEmptyObject(themeOverrides.base);
  const originalBaseStyles = normalizeBaseStyles(
    styles.base,
    theme,
    mergedProps
  );
  if (hasThemeBase) {
    const themeOverrideBaseStyles = normalizeBaseStyles(
      themeOverrides.base,
      theme,
      mergedProps
    );
    return originalBaseStyles.concat(themeOverrideBaseStyles);
  } else {
    return originalBaseStyles;
  }
}
function normalizeBaseStyles(base, theme, mergedProps) {
  if (!base) return EMPTY_ARRAY;
  return toArray(base).map((styles) => {
    return isFunction2(styles) ? styles({ theme, props: mergedProps }) : styles;
  });
}
function getMergedStylesFromVariants(styles, themeOverrides, mergedProps, theme) {
  const originalVariants = normalizeVariants(
    styles.variants,
    theme,
    mergedProps
  );
  const result = [
    getStylesFromVariant(originalVariants, mergedProps)
  ];
  const hasThemeVariants = !isEmptyObject(themeOverrides.variants);
  if (hasThemeVariants) {
    const overridesVariants = normalizeVariants(
      themeOverrides.variants,
      theme,
      mergedProps
    );
    result.push(getStylesFromVariant(overridesVariants, mergedProps));
  }
  return result;
}
function normalizeVariants(variants, theme, mergedProps) {
  if (!variants) return EMPTY_OBJECT;
  return isFunction2(variants) ? variants({ theme, props: mergedProps }) : variants;
}
function getStylesFromVariant(variants, mergedProps) {
  var _a;
  const hasVariantProp = containsVariantProp(mergedProps);
  if (!hasVariantProp) {
    return EMPTY_OBJECT;
  }
  return (_a = variants[mergedProps.variant]) != null ? _a : EMPTY_OBJECT;
}
function getMergedStylesFromResponsiveVariants(styles, themeOverrides, mergedProps, theme) {
  const originalResponsiveVariants = normalizeResponsiveVariants(
    styles.responsiveVariants,
    theme,
    mergedProps
  );
  let mergedResponsiveVariants = originalResponsiveVariants;
  const hasThemeResponsiveVariants = themeOverrides.responsiveVariants.length > 0;
  if (hasThemeResponsiveVariants) {
    mergedResponsiveVariants = mergeResponsiveVariants(
      originalResponsiveVariants,
      // we don't need to normalize these, because the theme can't contain functions
      themeOverrides.responsiveVariants
    );
  }
  const variantPropValue = mergedProps.variant;
  const responsiveVariantStyles = mergedResponsiveVariants.map(
    (variantConfig) => {
      const variant = resolveResponsiveVariant(variantConfig, variantPropValue);
      return createResponsiveVariant(variantConfig.prop, variant, theme);
    }
  );
  return responsiveVariantStyles;
}
function normalizeResponsiveVariants(responsiveVariants, theme, mergedProps) {
  if (!responsiveVariants) return EMPTY_ARRAY;
  return responsiveVariants.map(({ variants, ...rest }) => {
    const applied = isFunction2(variants) ? variants({ theme, props: mergedProps }) : variants;
    return {
      variants: applied,
      ...rest
    };
  });
}
function mergeResponsiveVariants(originalResponsiveStyles, themeOverridesResponsiveStyles) {
  return originalResponsiveStyles.map((variant) => {
    const themeResponsiveVariant = themeOverridesResponsiveStyles.find(
      (responsiveVariant) => responsiveVariant.id === variant.id
    );
    if (!themeResponsiveVariant) {
      return variant;
    }
    return mergeAll2([variant, themeResponsiveVariant]);
  });
}
function resolveResponsiveVariant(variantConfig, variantPropValue) {
  if (variantPropValue) {
    const nestedVariantStyles = tryGetNestedVariantStyles(
      variantConfig,
      variantPropValue
    );
    if (nestedVariantStyles) {
      return nestedVariantStyles;
    }
  }
  return variantConfig.variants;
}
function tryGetNestedVariantStyles({ variants, prop }, variantPropValue) {
  const nestedVariantStyles = variants[variantPropValue];
  if (nestedVariantStyles && prop !== void 0) {
    const propAsArray = toArray(prop);
    for (const rawPropValue of propAsArray) {
      const key = typeof rawPropValue === "string" ? rawPropValue : rawPropValue + "";
      if (key in nestedVariantStyles) {
        return nestedVariantStyles;
      }
    }
  }
  return null;
}
var MERGE_ORDER_DEFAULT = [
  "base",
  "variants",
  "responsiveVariants"
];
function orderStylesByMergeOrder(mergeOrder, stylesMap) {
  const allStylesMerged = [];
  for (const orderingKey of mergeOrder) {
    const styles = stylesMap[orderingKey];
    if (styles.length) {
      allStylesMerged.push(...styles);
    }
  }
  return allStylesMerged;
}

// src/render-element.tsx
import React6 from "react";
import {
  isComponentType,
  isRenderFunction
} from "@stepstone-genesis/utilities";
var renderElement = (element, props) => {
  if (!element) return null;
  if (React6.isValidElement(element)) {
    return React6.cloneElement(element, { ...props, ...element.props });
  }
  if (isRenderFunction(element)) {
    const el = element();
    return React6.cloneElement(el, { ...props, ...el.props });
  }
  if (isComponentType(element)) {
    return React6.createElement(element, props);
  }
  return null;
};
export {
  Base,
  EmotionInstanceContext,
  GlobalStyles,
  InstanceProvider,
  ThemeProvider,
  __inefficientlyShallowMergeStyles,
  aliases,
  createCss,
  createCustomInstance,
  createResponsiveVariant,
  createStyleCache,
  css,
  defaultBreakpoints2 as defaultBreakpoints,
  get,
  getMediaQueries,
  getStylePropsHash,
  merge,
  mergeClassnames,
  mergeStyles,
  multiples,
  omit,
  pseudoSelectors,
  renderElement,
  scales,
  systemEmotionInstance,
  systemForwardRef,
  useEmotionCache,
  useEmotionInstanceContext,
  useGlobalStyles,
  useMergeStyles,
  useMultipleResponsiveVariant,
  useResponsiveVariant,
  useStyleCache,
  useStyleConfig,
  useStyles,
  useStylesInternal,
  useStylesOld,
  useTheme
};
